import Model, { belongsTo, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ComparisonSet } from 'frontend-utils/utils/constants/benchmark-insight';
import type { BeniBreakdown, BeniMeta } from 'lumen/models';

export default class BeniPaceApiResponse extends Model {
  [Type] = 'benchmark-insight/pace-api-response' as const;

  @belongsTo('benchmark-insight/meta', { async: false, inverse: null })
  declare meta: BeniMeta;

  @hasMany('benchmark-insight/breakdown', { async: false, inverse: null })
  declare day: BeniBreakdown[];

  get filteredDaySegmentations(): Partial<{
    [key in ComparisonSet]: BeniBreakdown[];
  }> {
    const filteredSegmentations = this.filterSegmentationsByComparisonSetType(
      this.day,
    );
    return filteredSegmentations;
  }

  filterSegmentationsByComparisonSetType(
    segmentations: BeniBreakdown[],
  ): Partial<{ [key in ComparisonSet]: BeniBreakdown[] }> {
    const filteredSegmentations: Partial<{
      [key in ComparisonSet]: BeniBreakdown[];
    }> = {};

    const visibleComparisonSetTypes = this.meta.comparisonSets
      .filter((comparisonSet) => comparisonSet.isVisible)
      .map((comparisonSet) => comparisonSet.comparisonSetType);

    // We only show data for the visible comparison sets, so these are the only ones we need to filter.
    visibleComparisonSetTypes.forEach((comparisonSetType) => {
      filteredSegmentations[comparisonSetType] = segmentations.filter(
        (segmentation) => segmentation.comparisonSetType === comparisonSetType,
      );
    });

    return filteredSegmentations;
  }
}
